import type { FC, ReactNode } from 'react';
import { Flex, Typography } from 'antd';
import { WORK_ORDER_UI } from '~/app/components/maintenance/work-orders/work-order-ui-colors';

export interface KanbanSortOptionLabelProps {
  icon: ReactNode;
  label: string;
  /** Soft tint behind the icon so the mode is scannable at a glance. */
  color: string;
  compact?: boolean;
}

export const KanbanSortOptionLabel: FC<KanbanSortOptionLabelProps> = ({
  icon,
  label,
  color,
  compact = false,
}) => (
  <Flex align="center" gap={compact ? 6 : 8} style={{ minWidth: 0 }}>
    <span
      aria-hidden
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: compact ? 20 : 22,
        height: compact ? 20 : 22,
        borderRadius: 6,
        flexShrink: 0,
        background: `${color}18`,
        color,
        fontSize: compact ? 12 : 13,
      }}
    >
      {icon}
    </span>
    <Typography.Text
      ellipsis
      style={{
        margin: 0,
        fontSize: compact ? 12 : 13,
        color: WORK_ORDER_UI.sidebarNavy,
      }}
    >
      {label}
    </Typography.Text>
  </Flex>
);
